import { get } from "@ember/object"
import type {
  Planbook,
  PlanbookCalendarDate,
  PlanbookCalendarDateCustom,
  PlanbookCalendarDateDefault,
  PlanbookDateAnnotationSingle,
} from "@shared/models/planbook"
import { filter, find, sortBy } from "lodash-es"

/*
Tests for is-ness
*/

export function isPlanbookDateCustom(cd: PlanbookCalendarDate): cd is PlanbookCalendarDateCustom {
  return (cd as PlanbookCalendarDateCustom).type === "planbook-date-custom"
}

export function isPlanbookDateDefault(cd: PlanbookCalendarDate): cd is PlanbookCalendarDateDefault {
  return (cd as PlanbookCalendarDateDefault).type === "planbook-date-default"
}
export function isPlanbookDateAnnotationCustomSingle(
  ann: PlanbookDateAnnotationSingle
): ann is PlanbookDateAnnotationSingle {
  return (ann as PlanbookDateAnnotationSingle).type === "date-annotation-planbook-custom-single"
}

/*
  Tests for matching
*/

export function isMatchingPlanbookDateCustom(
  dateString: string,
  cd: PlanbookCalendarDate
): cd is PlanbookCalendarDateCustom {
  return (
    (cd as PlanbookCalendarDateCustom).type === "planbook-date-custom" &&
    (cd as PlanbookCalendarDateCustom).attributes.dateString === dateString
  )
}

export function isMatchingPlanbookDateDefault(
  rotationId: string | null | undefined,
  semesterId: string | null | undefined,
  cd: PlanbookCalendarDate
): cd is PlanbookCalendarDateDefault {
  return (
    (cd as PlanbookCalendarDateDefault).type === "planbook-date-default" &&
    (cd as PlanbookCalendarDateDefault).attributes.rotationId === rotationId &&
    (cd as PlanbookCalendarDateDefault).attributes.semesterId === semesterId
  )
}

/*
  Functionn to filter for desired types of dates
*/

export function filterPlanbookDefaultDates(planbook: Planbook): Array<PlanbookCalendarDateDefault> {
  return filter(get(planbook.attributes.calendar, "dates"), isPlanbookDateDefault)
}

export function filterPlanbookCustomDates(planbook: Planbook): Array<PlanbookCalendarDateCustom> {
  return sortBy(
    filter(get(planbook.attributes.calendar, "dates"), isPlanbookDateCustom),
    "attributes.dateString"
  )
}

/*

  Functions to find the date
*/

export function findPlanbookDefaultDate(
  planbook: Planbook,
  {
    rotationId,
    semesterId,
  }: { rotationId: string | null | undefined; semesterId: string | null | undefined }
): PlanbookCalendarDateDefault | undefined {
  return find(
    get(planbook.attributes.calendar, "dates"),
    isMatchingPlanbookDateDefault.bind(this, rotationId, semesterId)
  )
}

export function findPlanbookCustomDate(
  planbook: Planbook,
  dateString: string
): PlanbookCalendarDateCustom | undefined {
  return find(
    get(planbook.attributes.calendar, "dates"),
    isMatchingPlanbookDateCustom.bind(this, dateString)
  )
}
